// subcomponents/one_time_income/TableSummary.js
import {Table} from "antd";

const {Summary} = Table;

const TableSummary = ({pageData}) => {
    if (!pageData || pageData.length === 0) return null;

    const totals = pageData.reduce(
        (acc, item) => {
            const cost = item.cost || 0;
            const nds = item.nds || 0;
            const totalWithNds = nds === 21 ? cost * 1.21 : cost;

            acc.totalCost += cost;
            acc.totalWithNds += totalWithNds;

            if (item.type === 1) acc.cashTotal += totalWithNds;
            if (item.type === 2) acc.nonCashTotal += totalWithNds;

            return acc;
        },
        {totalCost: 0, totalWithNds: 0, cashTotal: 0, nonCashTotal: 0}
    );

    return (
        <Summary.Row>
            <Summary.Cell index={0} colSpan={2} align="left">
                <strong>Итого:</strong>
            </Summary.Cell>
            <Summary.Cell index={1} align="right">
                <strong></strong>
            </Summary.Cell>
            <Summary.Cell index={3} align="right">
                <strong style={{color: '#1890ff'}}></strong>
            </Summary.Cell>
            <Summary.Cell index={1} align="right">
                <div>
                    Без НДС: <strong>{totals.totalCost.toFixed(2)} €</strong>
                </div>
                <div>
                    С НДС: <strong style={{color: '#1890ff'}}>{totals.totalWithNds.toFixed(2)} €</strong>
                </div>
            </Summary.Cell>
            <Summary.Cell index={3} align="right">
                <strong style={{color: '#1890ff'}}></strong>
            </Summary.Cell>
            <Summary.Cell index={3} align="right">
                <strong style={{color: '#1890ff'}}></strong>
            </Summary.Cell>
        </Summary.Row>
    );
};

export default TableSummary;